import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { clamp } from '../../../utils/clamp.es.js';

const root = "_root_8t3l7_1";
const progress = "_progress_8t3l7_9";
const styles = {
	root: root,
	progress: progress
};

const ProgressBar = (_a) => {
  var { max = 1, min = 0, color = "UiPrimaryStrongest" } = _a, props = __rest(_a, ["max", "min", "color"]);
  const value = clamp(props.value, min, max);
  const range = max - min;
  const decimal = (value - min) / range;
  const width = `${decimal * 100}%`;
  return React__default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    React__default.createElement("div", { className: styles.progress, "data-testid": "progress", "data-zds": true, style: {
      "--progress-bar-width": width,
      "--progress-bar-color": Colors[color]
    } })
  );
};

export { ProgressBar };
//# sourceMappingURL=ProgressBar.es.js.map
